import React from 'react';
import PropTypes from 'prop-types';
import { pure } from '@dbk/ui-react-utils';
import { FormattedDate } from '@dbk/format';
import Text, {XSmall} from '../text';
import omit from 'lodash/omit';
import { NO_DATA } from '../../../constants';

const FullMonthYear = props => {
  if (props.value && typeof props.value === 'string') {
    return (
      props.onlySmallMonth ?
        <FormattedDate
          month="short"
          value={new Date(props.value)}
          {...omit(props, 'value', 'renderProps')}
        >{(txt) => <XSmall style={{color: props.color}} {...props.renderProps}> {txt.toUpperCase()}</XSmall>}
        </FormattedDate>
      :
      <FormattedDate
        month="long"
        year="numeric"
        value={new Date(props.value)}
        {...omit(props, 'value', 'renderProps')}
      >{(txt) => <Text {...props.renderProps}> {txt}</Text>}
      </FormattedDate>
    );
  }
  return <Text {...props.renderProps}> {NO_DATA}</Text>;
};

FullMonthYear.propTypes = {
  ...FormattedDate.PropTypes,
  value: PropTypes.any,
};

export default pure(FullMonthYear);
